import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import moment from "moment";
import jQuery from "jquery";

// Expose moment and jquery globally for compatibility with older libraries like daterangepicker
// We use .default fallback because Vite sometimes wraps CommonJS modules
window.moment = moment?.default || moment;
window.jQuery = window.$ = jQuery?.default || jQuery;

// Polyfill for findDOMNode removed in React 19
// Required for compatibility with react-bootstrap and other older libraries
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (instance) => {
    if (instance == null) {
      return null;
    }
    // If it's already a DOM node, return it
    if (instance.nodeType === 1) {
      return instance;
    }
    // For React components with refs
    if (instance._reactInternals) {
      const fiber = instance._reactInternals;
      // Try to get the stateNode (the actual DOM node)
      if (fiber.stateNode && fiber.stateNode.nodeType === 1) {
        return fiber.stateNode;
      }
      // Walk up the fiber tree to find a DOM node
      let currentFiber = fiber.child;
      while (currentFiber) {
        if (currentFiber.stateNode && currentFiber.stateNode.nodeType === 1) {
          return currentFiber.stateNode;
        }
        currentFiber = currentFiber.child;
      }
    }
    // Last resort: try to access stateNode directly
    return instance.stateNode || null;
  };
}

// import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
if (window?.api?.isElectron) {
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
